import classNames from "classnames/bind";
import React from "react";
import { InputStackProps } from "./types";
import FormLabel from "./FormLabel";
import styles from "./InputStack.module.scss";

const cx = classNames.bind(styles);

/** @deprecated manually build input stacks */
const InputStack = ({
  name,
  label,
  className,
  style,
  children,
  isDisabled,
}: InputStackProps) => (
  <div
    className={className}
    style={style}
  >
    <FormLabel
      inputId={`${name}Stack`}
      label={label}
      isDisabled={isDisabled}
    />
    <div
      className={cx("stack")}
      role="group"
      aria-labelledby={`${name}Stack`}
    >
      {children}
    </div>
  </div>
);

export default InputStack;
